import { render, staticRenderFns } from "./RightBanner.vue?vue&type=template&id=dd75628c&scoped=true"
import script from "./RightBanner.vue?vue&type=script&lang=ts"
export * from "./RightBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd75628c",
  null
  
)

export default component.exports